import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { ScreenDesignDocumentService } from "../../../../services/document-service";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import PlusIcon from "../../../../svgs/small-icons/plus-icon.svg";
import { DeleteModal } from "../../../common/delete-modal";
import KuikaDropdownMenu, { KuikaDropdownMenuItemType } from "../../../ui-kit/kuika-dropdown-menu/kuika-dropdown-menu";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTooltip from "../../../ui-kit/kuika-tooltip/kuika-tooltip";
import KuikaSmallText from "../../../ui-kit/typography/SmallText/SmallText";
import { DocumentModal } from "./document-modal";
import "./documents-window.scss";

export interface IDocumentsWindowState {
  triggerScreenDeleteModal: boolean;
  isDocumentModalActive: boolean;
  documentToDelete: string;
  documentToDeleteName: string;
  documentId: string;
  documentName: string;
  documentLink: string;
  searchKeyWords: string[];
  searchText: string;
}

export interface IDocumentsWindowProps {}

class DocumentsWindow extends PureSdComponent<
  IDocumentsWindowProps & IWithSDProps & IWithContextProp,
  IDocumentsWindowState
> {
  constructor(props: IDocumentsWindowProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = {
      triggerScreenDeleteModal: false,
      isDocumentModalActive: false,
      documentToDelete: "",
      documentToDeleteName: "",
      documentId: "",
      documentName: "",
      documentLink: "",
      searchKeyWords: [],
      searchText: ""
    };
  }

  componentDidMount = () => {
    this.reloadDocumentList();
  };

  handleDocumentClick = () => {
    try {
      this.setState({
        isDocumentModalActive: true
      });
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  };

  closeDocumentModal = () => {
    this.setState({ isDocumentModalActive: false });
    this.setState({ documentId: "", documentName: "", documentLink: "" });
  };

  reloadDocumentList = () => {
    this.props.sd.updateProjectDocumentsList();
  };

  // Called from the dropdown menu, which hands its handlers rc-menu's click *info* object rather
  // than a DOM event — there is nothing to stop propagation on, and nothing to stop: the menu is
  // portalled out of this panel.
  triggerDeleteDocument = (id: string, name: string): void => {
    this.setState({
      triggerScreenDeleteModal: true,
      documentToDelete: id,
      documentToDeleteName: name
    });
  };

  async deleteDocument() {
    try {
      const res = await ScreenDesignDocumentService.Delete(this.state.documentToDelete);
      if (res === true) {
        KMainFunctions.displaySuccessNotification(`Document has been deleted successfully.`);
        this.reloadDocumentList();
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  editDocument = (id: string, name: string, link: string): void => {
    this.setState({ documentId: id, documentName: name, documentLink: link });
    this.handleDocumentClick();
  };

  handleSearchInputChange = (e: any) => {
    this.setState({
      searchKeyWords: e.target.value.split(" "),
      searchText: e.target.value
    });
  };

  deleteSearchText = () => this.setState({ searchKeyWords: [], searchText: "" });

  render() {
    if (!this.props || !this.props.sd) {
      return <></>;
    }
    const sd = this.props.sd.getScreenDesign();
    const selectedDisplayItem = this.props.sd.getSelectedDisplayItem(sd);
    if (!selectedDisplayItem) {
      return <></>;
    }

    // "Go to URL" stays a real anchor rather than becoming a click handler: the row is a link,
    // so it should still be middle-clickable and its address copyable from the context menu.
    const documentScreen = (id: string, name: string, link: string): KuikaDropdownMenuItemType[] => [
      {
        key: "go-to-url",
        label: (
          <a className="kuika-documents__menu-link" href={link} target="_blank" rel="noopener noreferrer">
            Go to URL
          </a>
        ),
        dataTestId: "documentGoToUrl"
      },
      {
        key: "edit",
        label: "Edit",
        onClick: () => this.editDocument(id, name, link)
      },
      {
        key: "delete",
        label: "Delete",
        danger: true,
        onClick: () => this.triggerDeleteDocument(id, name)
      }
    ];

    return (
      <>
        <DeleteModal
          itemName={this.state.documentToDeleteName}
          triggerModal={this.state.triggerScreenDeleteModal}
          deleteItem={() => this.deleteDocument()}
          deleteType={"Document"}
          closeModal={() =>
            this.setState({
              triggerScreenDeleteModal: false,
              documentToDeleteName: ""
            })
          }
        />
        <DocumentModal
          showModal={this.state.isDocumentModalActive}
          closeModal={this.closeDocumentModal}
          screenId={this.props.sd.sdId}
          reloadDocumentList={this.reloadDocumentList}
          documentId={this.state.documentId}
          documentName={this.state.documentName}
          documentLink={this.state.documentLink}
        ></DocumentModal>
        <div style={{ width: "100%", paddingBottom: 20 }}>
          <div className="kuika_right-panel__header" style={{ borderBottom: "none" }}>
            <span className="kuika_right-panel__header__title">Documents</span>
            <span style={{ float: "right" }}>
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                viewBox="0 0 23 23"
              >
                <g fill="none" fillRule="evenodd">
                  <path d="M0 0H23V23H0z" />
                  <path
                    fill="#666666"
                    fillRule="nonzero"
                    d="M6 10c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zm6 0c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zm6 0c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"
                  />
                </g>
              </svg> */}
            </span>
          </div>
          <div style={{ overflowY: "auto", height: "calc(100vh - 89px)" }}>
            <div className="kuika-panel-search" style={{ marginBottom: 12 }}>
              <KuikaInput
                data-testid="documentSearchInput"
                placeholder="Search..."
                borderless
                size="lg"
                value={this.state.searchText}
                onChange={this.handleSearchInputChange}
                leftIcon={<KuikaSvg name="search" width={16} height={16} />}
                rightIcon={
                  this.state.searchText ? (
                    <KuikaSvg
                      data-testid="deleteDocumentSearchText"
                      onClick={this.deleteSearchText}
                      name="x"
                      width={16}
                      height={16}
                      pointer
                    />
                  ) : undefined
                }
              />
            </div>
            <div
              onClick={this.handleDocumentClick}
              className="kuika_add_new_panel_item kuika_centered"
              style={{ justifyContent: "left" }}
            >
              <PlusIcon
                style={{
                  width: 12,
                  filter: "invert(33%) sepia(82%) saturate(2570%) hue-rotate(211deg) brightness(99%) contrast(104%)"
                }}
              />
              <span style={{ marginLeft: "4px" }}>New Document</span>
            </div>
            <div>
              {this.props.sd.projectDocumentList
                ?.filter((doc) => doc?.name?.toLowerCase()?.startsWith(this.state.searchText.toLowerCase()))
                ?.map((d) => (
                  <div key={d.id} className="kuika_documentList_item kuika-documents__row">
                    <div className="kuika-documents__name-cell">
                      <KuikaTooltip position="bottom" content={d.link}>
                        <KuikaSmallText className="kuika-documents__name">{d.name}</KuikaSmallText>
                      </KuikaTooltip>
                    </div>
                    <div className="kuika-documents__actions-cell kuika_screenHistorySvg">
                      <KuikaDropdownMenu
                        options={documentScreen(d.id, d.name, d.link)}
                        trigger="click"
                        placement="bottomRight"
                      >
                        <KuikaSvg
                          data-testid={`documentMenuButton-${d.name?.replace(/\s+/g, "").toLowerCase()}`}
                          name="dots"
                          width={16}
                          height={16}
                          pointer
                        />
                      </KuikaDropdownMenu>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const documentsWindow = withContext<IDocumentsWindowProps>(withSD<IDocumentsWindowProps>(DocumentsWindow));
export { documentsWindow as DocumentsWindow };
